import { useState } from "react";
import MaintenanceAlertsSidebar, { MaintenanceAlertsFilter } from "@components/Maintenance/AlertsSidebar";
import AlertsSummaryCard, { AlertsSummaryItem } from "@components/shared/AlertsSummaryCard";
import AlertsRecentCardSkeleton from "@components/Skeletons/AlertsRecentCardSkeleton";
import { useT } from "@hooks";
import {
  MAINTENANCE_ALERT_TYPES,
  MaintenanceAlertTotals,
  MaintenanceAlertType,
  MaintenancePeriod,
} from "@services/maintenance";

interface MaintenanceAlertsCardProps {
  totals?: MaintenanceAlertTotals;
  period: MaintenancePeriod;
}

export default function MaintenanceAlertsCard({ totals, period }: Readonly<MaintenanceAlertsCardProps>) {
  const t = useT();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [initialFilter, setInitialFilter] = useState<MaintenanceAlertsFilter>("ALL");

  if (!totals) {
    return <AlertsRecentCardSkeleton items={MAINTENANCE_ALERT_TYPES.length} />;
  }

  const openSidebar = (filter: MaintenanceAlertsFilter) => {
    setInitialFilter(filter);
    setIsSidebarOpen(true);
  };

  const items: AlertsSummaryItem<MaintenanceAlertType>[] = MAINTENANCE_ALERT_TYPES.map((type) => ({
    id: type,
    label: t(`maintenance.alerts.type.${type}`),
    count: totals.alerts[type] ?? 0,
  }));

  return (
    <AlertsSummaryCard
      title={t("maintenance.alerts.title")}
      historyLabel={t("maintenance.alerts.history")}
      totalCount={totals.total}
      items={items}
      onItemClick={openSidebar}
      onHistoryClick={() => openSidebar("ALL")}
    >
      <MaintenanceAlertsSidebar
        open={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        initialFilter={initialFilter}
        period={period}
      />
    </AlertsSummaryCard>
  );
}
